<template>
  <div class="container">
    <div>
      <el-form
        size="mini"
        ref="form"
        :model="searchInfo"
        inline
        class="teacherDetails"
        @submit.native.prevent
      >
        <el-form-item label="教师搜索:">
          <el-input
            placeholder="教师名字/手机号"
            v-model="searchInfo.key_word"
            @change="handleSearch"
            @clear="handleSearch"
            prefix-icon="el-icon-search"
            clearable
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="在职状态:">
          <!-- <el-select
            v-model="searchInfo.on_job"
            placeholder="请选择"
            class="drawer_onlychoose"
            @change="handleSearch"
            clearable
          >
            <el-option
              v-for="item in jobList"
              :key="item.value"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select> -->
          <el-radio-group
            v-model="searchInfo.on_job"
            size="mini"
            @change="handleSearch"
          >
            <el-radio-button :label="0">全部</el-radio-button>
            <el-radio-button :label="1">在职</el-radio-button>
            <el-radio-button :label="2">离职</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-table
        size="mini"
        v-horizontal-scroll
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        :data="tableData"
        stripe
      >
        <el-table-column label="排序">
          <template slot-scope="scope">
            <sort-editor
              :id="scope.row.teacher_id"
              :ori="scope.row.sort"
            ></sort-editor>
          </template>
        </el-table-column>
        <el-table-column label="教师姓名" prop="name"> </el-table-column>
        <el-table-column label="性别" prop="sex"> </el-table-column>
        <el-table-column
          label="固定休息时间"
          prop="resting_time"
          min-width="120"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.resting_time
                  .map((item) => {
                    return weekArr[item];
                  })
                  .join("、") || "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="其他授权" prop="other_authorize">
        </el-table-column>
        <el-table-column label="在职状态">
          <template slot-scope="scope">
            <div :class="[scope.row.on_job_status == '在职' ? 'green' : 'red']">
              {{ scope.row.on_job_status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" width="90">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_show"
              @change="setStaffVisible(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <div class="mwow-button primary" @click="clickDetail(scope.row)">
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearBloth">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          :style="{ float: 'right', padding: '17px' }"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { setStaffVisibleApi } from "@/api/staff";
import { teacherList, modifysort, teacherListData } from "@/api/teacherManage";
import { PageModule } from "@/store/module/page";
import sortEditor from "../sortEditor.vue";
export default {
  props: ["visible"],
  components: {
    sortEditor,
  },
  data() {
    return {
      tableData: [],
      activeName: "teacher",
      showDetails: false,
      showDetailsId: "",
      // jobList = [
      //   { value: "在职", key: 1 },
      //   { value: "离职", key: 2 },
      // ];
      searchInfo: {
        on_job: 1,
      },
      weekArr: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      searTypeenter: "",
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      sortNumber: "",
      inputbtn: true,
    };
  },
  created() {
    const _t = this;
    const pageData = PageModule.pageInfo.teacherMange;
    if (pageData.page) {
      _t.page = pageData.page;
    }
    const cache = PageModule.pageInfo.teacherDetails;
    if (cache.tab) {
      PageModule.SET_PAGE_INFO({
        name: "teacherDetails",
        key: "tab",
        value: "",
      });
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList({
          page: _t.page,
          page_size: _t.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    }
  },
  methods: {
    clickDetail(e) {
      const _t = this;
      _t.$router.push({
        name: "teacherDetails",
        query: { id: e.teacher_id, org_id: e.org_id },
      });
    },
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.key_word != "") {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.on_job > 0) {
        data.on_job = _t.searchInfo.on_job;
      }
      teacherList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((item) => {
              item.sortBtn = false;
              item.is_show = item.is_show === 1;
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        }
      });
    },
    handlePagerChange(e) {
      PageModule.SET_PAGE_INFO({
        name: "teacherMange",
        key: "page",
        value: e,
      });
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
    handleSearch() {
      const _t = this;
      _t.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    setStaffVisible(e) {
      const _t = this;
      const is_show = e.is_show ? 1 : 2;
      setStaffVisibleApi({ staff_id: e.teacher_id, is_show: is_show })
        .then((res) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch(() => {
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  background: #fff;
}
.teacherDetails {
  /deep/.el-form-item {
    margin-right: 79px;
  }
}
.el-tabs__item.is-top.is-active {
  color: #07d1aa !important;
}
.clearBloth {
  overflow: hidden;
}
.showeditBtn {
  margin: 0 10px;
}
.showedit {
  display: none;
}
.el-table__row:hover .showedit {
  display: block;
}
.green {
  color: #07d1aa;
}
.red {
  color: #f56c6c;
}
</style>
